export * from './components';
export { default as FranchiseeDetailsTab } from './FranchiseeDetailsTab';
export { default as FranchiseeDetails } from './FranchiseeDetails';
export { default as FranchiseeDepositsTab } from './FranchiseeDepositsTab';
export { default as FranchiseeDeposits } from './FranchiseeDeposits';
export { default as FranchiseeFundsTab } from './FranchiseeFundsTab';
export { default as FranchiseeFunds } from './FranchiseeFunds';
export { default as FranchiseeDataForm } from './FranchiseeDataForm';